// extracted by mini-css-extract-plugin
export default {"identityProviderContainer":"federated-idp-identity-providers-tab-container__identity-provider-container__vL2At"};